export default process.env.NEXT_PUBLIC_API_HOST || "";
